<div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">
  <div>Store
    <kendo-dropdownlist
      [data]="storeList"
      textField="display"
      valueField="storeID"
      [(ngModel)]="selectedValue"
      (valueChange)="storeValueChange($event)"
      name="selectedValue"
      style = "width: 170px; height: 30px; margin-top: 2px;">
    </kendo-dropdownlist>
  </div>
  <form novalidate #myForm="ngForm">
    <kendo-grid
      [kendoGridBinding]="gridData"
      [kendoGridSelectBy]="selectedCallback"
      [selectedKeys]="mySelection"
      (dataStateChange)="onStateChange($event)"
      (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)" (remove)="removeHandler($event)"
      (add)="addHandler($event, myForm)"
      [filterable]="true"
      [resizable]="true"
      [sortable]="true"
      [scrollable]="true"
      [pageSize]="gridState.take" [skip]="gridState.skip" [sort]="gridState.sort"
      [pageable]="{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: [20, 40, 60],
                  previousNext: true
                 }"
      style="height: 70vh; margin-top: 8px;">


      <kendo-grid-column field="itemGLCode" title="Item GL Code" filterable="true" [width]="150">
        <!--        <ng-template kendoGridEditTemplate let-dataItem="dataItem">-->
        <!--          <input [(ngModel)]="dataItem.itemGLCode" kendoGridFocusable name="itemGLCode" class="k-textbox" required/>-->
        <!--        </ng-template>-->
      </kendo-grid-column>

      <kendo-grid-column field="itemGLDesc" title="GL Code Description" filterable="true" [width]="150">
        <!--        <ng-template kendoGridEditTemplate let-dataItem="dataItem">-->
        <!--          <input [(ngModel)]="dataItem.itemGLDesc" kendoGridFocusable name="itemGLDesc" class="k-textbox" required/>-->
        <!--        </ng-template>-->
      </kendo-grid-column>

      <kendo-grid-column field="exportedGLCode" title="AP Export GL Code" filterable="true" [width]="150">
        <ng-template kendoGridEditTemplate let-dataItem="dataItem">
          <div *ngIf="uname.errors" style="color:red">
            <b>Name must be at least {{minSegLength}} characters long</b>
          </div>
          <input id="apExportGlCode" [(ngModel)]="dataItem.exportedGLCode" kendoGridFocusable name="exportedGLCode"
                 minLength="{{minSegLength}}"  maxLength="{{minSegLength}}" #uname="ngModel" class="k-textbox"/>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Actions" width="100">
        <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
          <button kendoGridEditCommand type="button" [primary]="true" style="margin-right: 8px; min-width: 60px;" >Edit</button>
          <button *ngIf="dataItem.exportedGLCode !== ''" kendoGridRemoveCommand type="button">Delete</button>
          <button
            kendoGridSaveCommand type="button"
            [disabled]="myForm.invalid || myForm.pristine && !minSegLength<9" [primary]="true" style="margin-right: 8px;">Update
          </button>
          <button kendoGridCancelCommand type="button">Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </form>
</div>

<div kendoDialogContainer></div>

